import { render } from "./DeleteCandidate.vue?vue&type=template&id=a61a2cd2&scoped=true"
import script from "./DeleteCandidate.vue?vue&type=script&lang=js"
export * from "./DeleteCandidate.vue?vue&type=script&lang=js"

import "../css/deleteCandidate.css?vue&type=style&index=0&id=a61a2cd2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Korisnik\\Desktop\\3. Semestar Mag\\VUI\\DiplomaInsight\\DiplomaInsight\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a61a2cd2"]])

export default __exports__